import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './form-item-bl-apply-now-pc.component.scss';

export class FormItemBlApplyNowPc extends Base {
	// form
	form: HTMLFormElement;
	submitBtn: Element[];
	wizard: HTMLFormElement;

	creditCheck: HTMLFormElement;
	// formFields: HTMLFormElement;

	thankYouContainer: HTMLFormElement;
	approvedContainer: HTMLFormElement;
	completeContainer: HTMLFormElement;

	initialForm: HTMLFormElement;
	callMedBackForm: HTMLFormElement;

	// inputs
	entityType: HTMLFormElement;
	bankType: HTMLFormElement;
	loanAmount: HTMLFormElement;
	southAfricanIdField: HTMLFormElement;
	businessReg: HTMLFormElement;

	// buttons
	buttonSubmit: Element;
	applyOnlineButton: HTMLFormElement;
	callMeBackButton: Element;
	bttDate: HTMLFormElement;
	bttTime: HTMLFormElement;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = Array.from(this.element.querySelectorAll('.js-blApplyPc__button--submit'));
		this.callMeBackButton = this.element.querySelector('.js-blApplyPc__button--cmb');
		this.applyOnlineButton = this.element.querySelector('.js-blApplyPc__button--apply');

		this.creditCheck = this.element.querySelector('input[name=creditcheck]');
		this.bttDate = this.element.querySelector('input[name=date]');
		this.bttTime = this.element.querySelector('input[name=time]');
		// this.formFields = this.element.querySelector('.form__fields--container');

		this.thankYouContainer = this.element.querySelector('.form__thankyou--container');
		this.approvedContainer = this.element.querySelector('.form__success--container-pc');
		this.completeContainer = this.element.querySelector('.form__success--container');
		this.wizard = this.element.querySelector('.form-container-wizard__wizard');

		this.initialForm = this.element.querySelector('.form__fields--container-pcfields');
		this.callMedBackForm = this.element.querySelector('.form__fields--container-cmbfields');

		this.entityType = this.element.querySelector('.js-apply-now-entity-type');
		this.bankType = this.element.querySelector('.js-bl-apply-now-pc__bank');
		this.loanAmount = this.element.querySelector('.js-bl-apply-now-pc__loan');
		this.businessReg = this.element.querySelector('.form__input--busReg');
		this.southAfricanIdField = this.element.querySelector('.form__input--saId');

		if (this.entityType) {
			this.updateForm(this.entityType.value);
		}
	}

	bindEvents() {
		this.submitBtn.map((item) => item.addEventListener('click', (event) => {
			const _button = event.target as HTMLFormElement;
			const _form = _button.closest('form') as HTMLFormElement;
			const formFields: any = _form.querySelectorAll('input, select');
			this.validationService.validate(formFields);
			const valid = Array.from(_form.querySelectorAll('.form__group--error'));
			if (valid.length === 0) {
				this.submitForm(_form);
			}
		}));
		if (this.buttonSubmit) {
			this.buttonSubmit.addEventListener('click', (event) => {
				const _button = event.target as HTMLFormElement;
				const _form = _button.closest('form') as HTMLFormElement;
				const formFields: any = _form.querySelectorAll('input, select');
				this.validationService.validate(formFields);
				const valid = Array.from(_form.querySelectorAll('.form__group--error'));
				if (valid.length === 0) {
					this.submitForm(_form);
				}
			});
		}

		if (this.entityType) {
			this.entityType.addEventListener('change', (event) => {
				this.updateForm(this.entityType.value);
			});
		}

		if (this.bankType) {
			this.bankType.addEventListener('change', (event) => {
				this.displayLoan(this.bankType.value);
			});
		}

		// This adds slashes to the business registration number
		if (this.businessReg) {
			this.businessReg.addEventListener('input', (event: any) => {
				if ((event.inputType !== 'deleteContentBackward') && (event.inputType !== 'deleteContentForward')) {
					const reg = event.target.value;
					event.target.value = this.validationService.formatBusinessReg(reg);
				}
			});

			this.businessReg.addEventListener('blur', (event: any) => {
				const reg = event.target.value;
				event.target.value = this.validationService.formatExpression(reg);
			});
		}

		if (this.callMeBackButton) {
			this.callMeBackButton.addEventListener('click', (event) => {
				this.showCallMeBack(true);
			});
		}

		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			// allow individual form items components to handle form reset
			if (this.wizard) {
				const event = new CustomEvent('custom_wizard_reset_event');
				this.wizard.dispatchEvent(event);
			}
			this.initialForm.classList.remove('hidden');
			this.approvedContainer.classList.remove('active');
			this.callMedBackForm.classList.add('hidden');
			const _creditCheck: any = this.form.querySelector('input[name=creditcheck]');
			if (_creditCheck) {
				_creditCheck.value = 'true';
			}
			const _fraudResponse: any = this.form.querySelector('input[name=fraudResponse]');
			if (_fraudResponse) {
				_fraudResponse.value = 'false';
			}
			const _amountResponse: any = this.form.querySelector('input[name=amountResponse]');
			if (_amountResponse) {
				_amountResponse.value = '';
			}
			// This will reset step 2
			if (this.entityType) {
				this.updateForm(this.entityType.value);
			}
			if (this.bankType && this.loanAmount) {
				this.displayLoan(this.bankType.value);
			}
			let _formName: any = this.form.getAttribute('data-frmcontainer');
			_formName = _formName.replace(' cmb', '');
			this.form.setAttribute('data-frmcontainer', _formName);

			const subjectMail: any = this.form.querySelector('input[name=subject_mail]');
			const subject: any = this.form.querySelector('input[name=subject]');
			if (subjectMail && subject) {
				subject.value = subjectMail.value;
			}
		}, false);
	}

	updateForm(type) {
		if (this.southAfricanIdField) {
			const _group = this.southAfricanIdField.closest('.form__group');
			if (type !== 'SOLE PROPRIETOR') {
				this.southAfricanIdField.classList.remove('form__input--required');
				_group.classList.add('form__group--hidden');

			} else {
				this.southAfricanIdField.classList.add('form__input--required');
				_group.classList.remove('form__group--hidden');
			}
		}

		if (this.businessReg) {
			const _group = this.businessReg.closest('.form__group ');
			if (type !== 'SOLE PROPRIETOR') {
				this.businessReg.classList.add('form__input--required');
				_group.classList.remove('form__group--hidden');

			} else {
				this.businessReg.classList.remove('form__input--required');
				_group.classList.add('form__group--hidden');
			}
		}

		if (this.bankType && this.loanAmount) {
			this.displayLoan(this.bankType.value);
		}
	}

	displayLoan(type) {
		if (this.loanAmount && this.entityType) {
			const _group = this.loanAmount.closest('.form__group');
			if (type === 'STANDARD BANK' || type === '') {
				this.loanAmount.classList.remove('form__input--required');
				_group.classList.add('form__group--hidden');
			} else {
				this.loanAmount.classList.add('form__input--required');
				_group.classList.remove('form__group--hidden');
			}
		}
	}

	showCallMeBack(pResetAnalytics: boolean = false) {
		this.initialForm.classList.add('hidden');
		this.initialForm.classList.remove('active');

		this.callMedBackForm.classList.add('active');
		this.callMedBackForm.classList.remove('hidden');

		this.approvedContainer.classList.add('hidden');
		this.approvedContainer.classList.remove('active');

		this.completeContainer.classList.add('hidden');
		this.completeContainer.classList.remove('active');

		this.creditCheck.value = 'false';

		if (pResetAnalytics) {
			const _formName = this.form.getAttribute('data-frmcontainer');
			if (_formName !== '') {
				this.form.setAttribute('data-frmcontainer', _formName + ' cmb');
			}
			this.analyticsService.dtmRestartForm();
		}
	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');

		// additional containers
		const declined = form.querySelector('.form__declined--container');
		const success = form.querySelector('.form__success--container');
		const successUpl = form.querySelector('.form__success--container-pc');
		const error = form.querySelector('.form__error--container');
		const value = form.querySelector('.output-value');
		const name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
		const contactNumber = Array.from(form.querySelectorAll('.form__success-container__contact'));
		const qualifiedAmount = form.querySelector('.form__success-container__approvedamount');
		const _initialForm = form.querySelector('.form__fields--container-pcfields') as HTMLFormElement;
		const _callMeBackForm = form.querySelector('.form__fields--container-cmbfields') as HTMLFormElement;

		// loader + hide form
		loader.classList.add('active');
		_initialForm.classList.add('hidden');
		_initialForm.classList.remove('active');

		let emailPostData = '';
		let powerCurvePostData = '';

		// hidden fields
		const description: any = form.querySelector('input[name=description]');
		emailPostData += 'description=' + ((description) ? description.value : '');
		const email: any = form.querySelector('input[name=email]');
		emailPostData += '&email=' + ((email) ? email.value : '');
		const recipient: any = form.querySelector('input[name=recipient]');
		emailPostData += '&recipient=' + ((recipient) ? recipient.value : '');
		powerCurvePostData += '&recipient=' + ((recipient) ? recipient.value : '');
		const subjectMail: any = form.querySelector('input[name=subject_mail]');
		emailPostData += '&subject=' + ((subjectMail) ? subjectMail.value : '');
		const subject: any = form.querySelector('input[name=subject]');
		powerCurvePostData += '&subject=' + ((subject) ? subject.value : '');
		const product: any = form.querySelector('input[name=product]');
		emailPostData += '&product=' + ((product) ? product.value : '');
		const redirect: any = form.querySelector('input[name=redirect]');
		emailPostData += '&redirect=' + ((redirect) ? redirect.value : '');

		// form fields
		const _firstName: any = form.querySelector('input[name=first-name]');
		emailPostData += '&first-name=' + ((_firstName) ? _firstName.value : '');
		powerCurvePostData += '&firstName=' + ((_firstName) ? _firstName.value : '');

		const _surname: any = form.querySelector('input[name=surname]');
		emailPostData += '&surname=' + ((_surname) ? _surname.value : '');
		powerCurvePostData += '&surName=' + ((_surname) ? _surname.value : '');

		const _contactNumber: any = form.querySelector('input[name=phone-number]');
		emailPostData += '&phone-number=' + ((_contactNumber) ? _contactNumber.value : '');
		powerCurvePostData += '&phoneNumber=' + ((_contactNumber) ? _contactNumber.value : '');

		const _email: any = form.querySelector('input[name=email-address]');
		emailPostData += '&email-address=' + ((_email) ? _email.value : '');
		powerCurvePostData += '&email=' + ((_email) ? _email.value : '');

		const _monthlyIncome: any = form.querySelector('input[name=monthly-income]');
		emailPostData += '&monthlyincome=' + ((_monthlyIncome) ? _monthlyIncome.value : '');
		powerCurvePostData += '&monthlyincome=' + ((_monthlyIncome) ? (_monthlyIncome.value * 12) : '');

		const _monthlyExpenses: any = form.querySelector('input[name=monthly-expenses]');
		emailPostData += '&monthlyexpenses=' + ((_monthlyExpenses) ? _monthlyExpenses.value : '');
		powerCurvePostData += '&monthlyexpenses=' + ((_monthlyExpenses) ? (_monthlyExpenses.value * 12) : '');

		const fraudConsent: any = form.querySelector('input[name=fraud-consent]');
		emailPostData += '&fraud-consent=' + ((fraudConsent) ? fraudConsent.value : '');
		powerCurvePostData += '&fraudConsent=' + ((fraudConsent) ? fraudConsent.value : '');

		const _entityType: any = form.querySelector('select[name=entity-type]');
		emailPostData += '&entity-type=' + ((_entityType) ? _entityType.value : '');

		const _businessName: any = form.querySelector('input[name=business-name]');
		emailPostData += '&business-name=' + ((_businessName) ? _businessName.value : '');
		powerCurvePostData += '&custorgname=' + ((_businessName) ? _businessName.value : '');

		const _idNumber: any = form.querySelector('input[name=sa-identity-number]');
		emailPostData += '&saId=' + ((_idNumber) ? _idNumber.value : '');
		powerCurvePostData += '&saId=' + ((_idNumber) ? _idNumber.value : '');

		const _businessRegNumber: any = form.querySelector('input[name=business-reg-number]');
		emailPostData += '&business-reg-number=' + ((_businessRegNumber) ? _businessRegNumber.value : '');

		const _businessIncome: any = form.querySelector('input[name=business-annual-income]');
		emailPostData += '&annualTurnOver=' + ((_businessIncome) ? _businessIncome.value : '');
		powerCurvePostData += '&annualTurnOver=' + ((_businessIncome) ? _businessIncome.value : '');

		const _businessExpenses: any = form.querySelector('input[name=business-annual-expenses]');
		emailPostData += '&annualexpneses=' + ((_businessExpenses) ? _businessExpenses.value : '');
		powerCurvePostData += '&annualexpneses=' + ((_businessExpenses) ? _businessExpenses.value : '');

		const _businessDescription: any = form.querySelector('textarea[name=business-description]');
		emailPostData += '&business-description=' + ((_businessDescription) ? _businessDescription.value : '');

		const _businessBank: any = form.querySelector('select[name=business-current-bank]');
		emailPostData += '&business-current-bank=' + ((_businessBank) ? _businessBank.value : '');

		const _businessAccountNumber: any = form.querySelector('input[name=business-account-number]');
		emailPostData += '&business-account-number=' + ((_businessAccountNumber) ? _businessAccountNumber.value : '');

		const _loanAmount: any = form.querySelector('input[name=loan-amount]');
		emailPostData += '&loan-amount=' + ((_loanAmount) ? _loanAmount.value : '');
		powerCurvePostData += '&loan-amount=' + ((_loanAmount) ? _loanAmount.value : '');

		const _purposeOfLoan: any = form.querySelector('textarea[name=purpose-of-loan]');
		emailPostData += '&purpose-of-loan=' + ((_purposeOfLoan) ? _purposeOfLoan.value : '');

		const _creditCheck: any = form.querySelector('input[name=creditcheck]');
		emailPostData += '&source=' + this.formsService.isMobile() + '&creditcheck=' + _creditCheck.value;
		powerCurvePostData += '&source=' + this.formsService.isMobile() + '&creditcheck=' + _creditCheck.value;

		if (_creditCheck.value === 'false') {
			const date: any = form.querySelector('input[name=date]');
			const time: any = form.querySelector('select[name=time]');
			if (date) {
				if (time) {
					if (time.value !== 'Anytime') {
						emailPostData += '&timeToCall=' + date.value + ' ' + time.value;
						powerCurvePostData += '&timeToCall=' + date.value + ' ' + time.value;
					} else {
						emailPostData += '&timeToCall=anytime';
						powerCurvePostData += '&timeToCall=anytime';
					}
				} else {
					emailPostData += '&timeToCall=anytime';
					powerCurvePostData += '&timeToCall=anytime';
				}
			}
		}

		const _fraudResponse: any = form.querySelector('input[name=fraudResponse]');
		powerCurvePostData += '&fraud=' + _fraudResponse.value;
		const _amountResponse: any = form.querySelector('input[name=amountResponse]');
		powerCurvePostData += '&amount=' + _amountResponse.value;

		// variables
		const analyticsService = new AnalyticsService();
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Access-Control-Allow-Origin': '*',
				'X-Requested-With': 'XMLHttpRequest'
			}
		};
		if (this.entityType.value === 'SOLE PROPRIETOR' && _businessBank.value === 'STANDARD BANK') {
			const url = '/services/brcpService.jsp';

			this.formsService.postForm(url, powerCurvePostData, config).then(pResponse => {
				loader.classList.remove('active');
				const _pResponse = pResponse.data;
				if (_pResponse === 'invalid') {
					analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
					thankYou.classList.add('active');
					error.classList.add('active');
				} else if (!_pResponse.error && (_pResponse.amount || _pResponse.code || _pResponse.leadID)) {
					if (_pResponse.amount) {
						analyticsService.dtmFormComplete('complete', 'true');
						thankYou.classList.add('active');
						declined.classList.remove('active');
						error.classList.remove('active');
						_amountResponse.value = _pResponse.amount;
						if (_creditCheck.value === 'true') {
							successUpl.classList.add('active');
							success.classList.remove('active');
						} else {
							successUpl.classList.remove('active');
							success.classList.add('active');
							success.classList.remove('hidden');
							_callMeBackForm.classList.remove('active');
							_callMeBackForm.classList.add('hidden');
						}
						name.map((_item) => {
							_item.innerHTML = _firstName.value;
						});
						contactNumber.map((_item) => {
							_item.innerHTML = _contactNumber.value;
						});
						value.innerHTML = 'R ' + _pResponse.amount;
						if (qualifiedAmount) {
							qualifiedAmount.innerHTML = _pResponse.amount;
						}
						subject.value = 'Your loan application is successful';
						_creditCheck.value = 'false';
					} else if (_pResponse.code) {
						analyticsService.dtmFormComplete('complete', _pResponse.code);
						const _tmp = this.errors.find((item) => {
							return item.code = _pResponse.code;
						});
						if (_tmp) {
							analyticsService.dtmRecordSiteError(_tmp.message);
						} else {
							analyticsService.dtmRecordSiteError('Access Quote Declined');
						}
						thankYou.classList.add('active');
						success.classList.remove('active');
						error.classList.remove('active');
						declined.classList.add('active');
						_creditCheck.value = 'false';
						subject.value = subjectMail.value;
					} else if (_pResponse.fraud) {
						analyticsService.dtmFormComplete('complete', _pResponse.fraud);
						_initialForm.classList.add('active');
						_callMeBackForm.classList.remove('active');
						_fraudResponse.value = _pResponse.fraud;
						thankYou.classList.add('active');
						success.classList.remove('active');
						error.classList.remove('active');
						declined.classList.add('active');
						_creditCheck.value = 'false';
						subject.value = 'Your loan application is in review';
					} else if (_pResponse.leadID) {
						analyticsService.dtmFormComplete('complete', _pResponse.leadID);
						_initialForm.classList.remove('active');
						_callMeBackForm.classList.remove('active');
						_callMeBackForm.classList.add('hidden');
						thankYou.classList.add('active');
						success.classList.add('active');
						success.classList.remove('hidden');
						error.classList.remove('active');
						declined.classList.remove('active');
						_creditCheck.value = 'false';
						subject.value = subjectMail.value;
					} else {
						analyticsService.dtmFormComplete('complete', _pResponse.code);
						const _tmp = this.errors.find((item) => {
							return item.code = _pResponse.code;
						});
						if (_tmp) {
							analyticsService.dtmRecordSiteError(_tmp.message);
						} else {
							analyticsService.dtmRecordSiteError('Access Quote Declined');
						}
						thankYou.classList.add('active');
						success.classList.remove('active');
						error.classList.remove('active');
						declined.classList.add('active');
					}
				} else {
					analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
					thankYou.classList.add('active');
					success.classList.remove('active');
					declined.classList.remove('active');
					error.classList.add('active');
				}
			}).catch(response => {
				// service failed
				analyticsService.dtmRecordSiteError('noerrorcode|service failure occurred|' + url);
				loader.classList.remove('active');
				_initialForm.classList.remove('hidden');
			});
		} else {
			const url = '/services/genericform.jsp';

			if (_creditCheck.value === 'true') {
				successUpl.classList.add('active');
				success.classList.remove('active');
				_callMeBackForm.classList.remove('hidden');
				loader.classList.remove('active');
				_creditCheck.value = 'false';
				name.map((_item) => {
					_item.innerHTML = _firstName.value;
				});
			} else {
				this.formsService.postForm(url, emailPostData, config).then(response => {
					loader.classList.remove('active');

					if (response.data === 'invalid') {
						analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
						thankYou.classList.add('active');
						error.classList.add('active');
					} else {
						analyticsService.dtmFormComplete('complete', response.code);
						successUpl.classList.remove('active');
						success.classList.add('active');
						success.classList.remove('hidden');
						_callMeBackForm.classList.remove('active');
						_callMeBackForm.classList.add('hidden');
						thankYou.classList.add('active');
						success.classList.add('active');
					}

				}).catch(response => {
					// service failed
					analyticsService.dtmRecordSiteError('noerrorcode|service failure occurred|' + url);
					loader.classList.remove('active');
					_initialForm.classList.remove('hidden');
				});
			}
		}
	}

	errors = [
		{
			'error': 'Credit Decline 1',
			'message': 'DD04_Score Decline',
			'code': 'DD04'
		},
		{
			'error': 'Decline 1',
			'message': 'DA58_No Bureau Consent_PS',
			'code': 'DA58'
		},
		{
			'error': 'Decline 2',
			'message': 'DA60_Under Admin Order_PS',
			'code': 'DA60'
		},
		{
			'error': 'Decline 3',
			'message': 'DA61_Under Sequestration_PS',
			'code': 'DA61'
		},
		{
			'error': 'Decline 4',
			'message': 'DA57_No Terms & Conditions_PS',
			'code': 'DA57'
		},
		{
			'error': 'Decline 5',
			'message': 'DA53_Under Debt Review',
			'code': 'DA53'
		},
		{
			'error': 'Decline 6',
			'message': 'DH67_Capture an RCP',
			'code': 'DH67'
		},
		{
			'error': 'Decline 7',
			'message': 'DA59_Customer Has No Surplus',
			'code': 'DA59'
		},
		{
			'error': 'Decline 8',
			'message': 'DD02_Adverse Status',
			'code': 'DD02'
		},
		{
			'error': 'Decline 9',
			'message': 'DR15_ID Warning',
			'code': 'DR15'
		},
		{
			'error': 'Decline 10',
			'message': 'DS47_No Bureau Information',
			'code': 'DS47'
		},
		{
			'error': 'Decline 11',
			'message': 'DA97_Bureau Debt Review',
			'code': 'DA97'
		},
		{
			'error': 'Decline 12',
			'message': 'DS43_Bureau Admin Order',
			'code': 'DS43'
		},
		{
			'error': 'Decline 13',
			'message': 'DD38_Reduction order on file',
			'code': 'DD38'
		},
		{
			'error': 'Decline 14',
			'message': 'DA18_Number of Dishonours L6M > 12',
			'code': 'DA18'
		},
		{
			'error': 'Decline 15',
			'message': 'DA19_Significant Days in Excess L6M > 60',
			'code': 'DA19'
		},
		{
			'error': 'Decline 16',
			'message': 'DD07_Bureau Not Clean',
			'code': 'DD07'
		},
		{
			'error': 'Decline 17',
			'message': 'DR38_Bureau Installments Exceeds Income',
			'code': 'DR38'
		},
		{
			'error': 'Decline 18',
			'message': 'DA36_Existing SBSA Loan on Record',
			'code': 'DA36'
		},
		{
			'error': 'Decline 19',
			'message': 'DD24_MasterCard Delinquent',
			'code': 'DD24'
		},
		{
			'error': 'Decline 20',
			'message': 'DD31_VAF Delinquent L6M',
			'code': 'DD31'
		},
		{
			'error': 'Decline 21',
			'message': 'DD30_Home Loan Delinquent',
			'code': 'DD30'
		},
		{
			'error': 'Decline 22',
			'message': 'DD39_WTP or ABIL Loan in Customer Profile',
			'code': 'DD39'
		},
		{
			'error': 'Decline 23',
			'message': 'DR32_Customer is part time employed',
			'code': 'DR32'
		},
		{
			'error': 'Decline 24',
			'message': 'DR58_Verification of Salary Required',
			'code': 'DR58'
		},
		{
			'error': 'Decline 25',
			'message': 'DA15_Customer is under 18',
			'code': 'DA15'
		},
		{
			'error': 'Decline 26',
			'message': 'DS16_Age > 65',
			'code': 'DS16'
		},
		{
			'error': 'Decline 27',
			'message': 'DA08_No Identification Given',
			'code': 'DA08'
		},
		{
			'error': 'Decline 28',
			'message': 'RA91_Advance Acnt Exposure - Refer to Credit',
			'code': 'RA91'
		},
		{
			'error': 'Decline 29',
			'message': 'RA92_Student Loan Exposure - Refer to Credit',
			'code': 'RA92'
		},
		{
			'error': 'Decline 30',
			'message': 'DR27_Foreign National',
			'code': 'DR27'
		},
		{
			'error': 'Decline 31',
			'message': 'RA14_Sefl Employed MTL',
			'code': 'RA14'
		},
		{
			'error': 'Decline 32',
			'message': 'RA96_Refer to Credit for Confirmation',
			'code': 'RA96'
		},
		{
			'error': 'Decline 33',
			'message': 'DR33_Customer employment status is unknown',
			'code': 'DR33'
		},
		{
			'error': 'Decline 34',
			'message': 'DA14_Non Resident',
			'code': 'DA14'
		},
		{
			'error': 'Decline 35',
			'message': 'DP19_One Account in Customer Profile',
			'code': 'DP19'
		},
		{
			'error': 'Decline 36',
			'message': 'DS49_Maximum Reprocess Allowed',
			'code': 'DS49'
		},
		{
			'error': 'Decline 37',
			'message': 'DS21_Low Income Loan Recently Granted',
			'code': 'DS21'
		},
		{
			'error': 'Decline 38',
			'message': 'DP95_LIUL Arrears',
			'code': 'DP95'
		},
		{
			'error': 'Decline 39',
			'message': 'DE42_Existing Loans is in arrears',
			'code': 'DE42'
		},
		{
			'error': 'Decline 40',
			'message': 'SD27_NLR Enquiry Last 1 Year',
			'code': 'SD27'
		},
		{
			'error': 'Decline 26',
			'message': 'DS18_Occupation Status not met',
			'code': 'DS18'
		},
		{
			'error': 'Decline 20',
			'message': 'DA38_GMI < 3000',
			'code': 'DA38'
		},
		{
			'error': 'Decline 21',
			'message': 'DD06_Self Employed',
			'code': 'DD06'
		},
		{
			'error': 'Decline 15',
			'message': 'DS09_Total Value of Judgments',
			'code': 'DS09'
		},
		{
			'error': 'Decline 13',
			'message': 'DS22_SAPPL Adverse Status',
			'code': 'DS22'
		},
		{
			'error': 'Decline 11',
			'message': 'DS23_Insufficient payment profile on Bureau',
			'code': 'DS23'
		},
		{
			'error': 'Refer 2',
			'message': 'RR40_Requested Limit < Current Outstanding Balance',
			'code': 'RR40'
		},
		{
			'error': 'Refer 3',
			'message': 'RA48_Age of Customer > 65',
			'code': 'RA48'
		},
		{
			'error': 'Decline 30',
			'message': 'DD25_Unpaid Credits L6m',
			'code': 'DD25'
		},
		{
			'error': 'Decline 31',
			'message': 'DS51_Missing Expenses',
			'code': 'DS51'
		},
		{
			'error': 'Decline 27',
			'message': 'DD23_Age of account < 6 months',
			'code': 'DD23'
		},
		{
			'error': 'Decline 28',
			'message': 'DD22_Recent limit increase',
			'code': 'DD22'
		},
		{
			'error': 'Decline 23',
			'message': 'DD37_Product not Permitted',
			'code': 'DD37'
		},
		{
			'error': 'Decline 6',
			'message': 'DA25_PL GMI < 6001 AND GMI < 8001',
			'code': 'DA25'
		},
		{
			'error': 'Decline 11',
			'message': 'DA35_Existing RCP',
			'code': 'DA35'
		},
		{
			'error': 'Decline 13',
			'message': 'DS40_Existing Loan',
			'code': 'DS40'
		},
		{
			'error': 'Decline 16',
			'message': 'DR60_Existing Advanced Account',
			'code': 'DR60'
		}
	];
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-bl-apply-now-pc/form-item-bl-apply-now-pc.component.ts